(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ms-bergfuehrer-anfrage"] && !Shopify.designMode) return;
  try {
    
/* Anfrageformular an einen Bergfuehrer. Kein Liquid hier, alles kommt
   ueber data-Attribute. Seit dem 19.09.2026 ohne fetch der Profile: der
   Bergfuehrer wird im Auswahlfeld gewaehlt (Wert = uuid aus Supabase). */
(function () {
  var TS_FRISCH_ALTER_MS = 15000;
  var TS_MAX_ALTER_MS = 12 * 60 * 60 * 1000;

  function namenSetzen(root, form) {
    var sel = form.querySelector('[data-bf-auswahl]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var name = (opt && opt.value) ? (opt.getAttribute('data-name') || opt.textContent) : '';
    var cnames = root.querySelectorAll('[data-bfp-cname]');
    for (var i = 0; i < cnames.length; i++) cnames[i].textContent = name || '…';
    var ct = form.querySelector('[name="consent_text"]');
    if (ct) ct.value = name
      ? (root.getAttribute('data-c1') || '') + name + (root.getAttribute('data-c2') || '') + name + (root.getAttribute('data-c3') || '')
      : '';
  }

  function formular(root) {
    var form = root.querySelector('#ms-bf-anfrage');
    if (!form || form.getAttribute('data-bound') === '1') return;
    form.setAttribute('data-bound', '1');

    var okBox = root.querySelector('#ms-bf-anfrage-success');
    var okText = root.querySelector('[data-bfp-ok-text]');
    var errBox = root.querySelector('#ms-bf-anfrage-error');
    var statusBox = root.querySelector('#ms-bf-anfrage-status');
    var spinner = root.querySelector('#ms-bf-anfrage-spinner');
    var submit = root.querySelector('#ms-bf-anfrage-submit');
    var consent = root.querySelector('#ms-bf-consent');
    var auswahl = form.querySelector('[data-bf-auswahl]');
    var ts = root.querySelector('#ms-bf-ts');
    var markiert = [];

    if (ts) ts.value = String(Date.now());
    function tsAuffrischen() {
      if (!ts) return;
      var jetzt = Date.now();
      var wert = parseInt(ts.value, 10);
      var alter = isNaN(wert) ? null : jetzt - wert;
      if (alter === null || alter < 0 || alter > TS_MAX_ALTER_MS) ts.value = String(jetzt - TS_FRISCH_ALTER_MS);
    }
    window.addEventListener('pageshow', tsAuffrischen);

    /* Der Name in der Einwilligung folgt der Auswahl. Beim Start einmal
       lesen: assets/ms-bergfuehrer.js kann den Wert schon gesetzt haben
       (?bergfuehrer=...), bevor dieses Skript gebunden war. */
    namenSetzen(root, form);
    if (auswahl) auswahl.addEventListener('change', function () { namenSetzen(root, form); });

    function feldZuName(name) {
      if (!name) return null;
      for (var i = 0; i < form.elements.length; i++) if (form.elements[i].name === name) return form.elements[i];
      return null;
    }
    function feldMarkieren(name) {
      var e = feldZuName(name);
      if (!e || e.type === 'hidden' || e.id === 'ms-bf-honig') return;
      e.setAttribute('aria-invalid', 'true');
      if (errBox) e.setAttribute('aria-describedby', errBox.id);
      markiert.push(e);
      if (typeof e.focus === 'function') e.focus();
      if (typeof e.scrollIntoView === 'function') e.scrollIntoView({ block: 'center' });
    }
    function markenLoeschen() {
      for (var i = 0; i < markiert.length; i++) { markiert[i].removeAttribute('aria-invalid'); markiert[i].removeAttribute('aria-describedby'); }
      markiert = [];
    }
    function showError(msg, feld) {
      if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
      if (feld) feldMarkieren(feld);
    }
    function clearError() {
      markenLoeschen();
      if (errBox) { errBox.textContent = ''; errBox.hidden = true; }
    }
    function setBusy(b) {
      if (submit) submit.disabled = b;
      if (spinner) spinner.hidden = !b;
      if (statusBox) statusBox.textContent = b ? (form.getAttribute('data-t-sending') || '') : '';
    }
    form.addEventListener('input', clearError);
    form.addEventListener('change', clearError);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      clearError();
      var endpoint = form.getAttribute('data-endpoint') || '';
      if (!endpoint) { showError(form.getAttribute('data-t-config') || ''); return; }
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        var erstes = form.querySelector(':invalid:not([type=hidden])');
        var fname = erstes && erstes.name;
        if (fname === 'profil_id') showError(form.getAttribute('data-t-guide') || '', 'profil_id');
        else if (fname === 'consent') showError(form.getAttribute('data-t-consent') || '', 'consent');
        else if (fname) showError(form.getAttribute('data-t-feld') || '', fname);
        else if (typeof form.reportValidity === 'function') form.reportValidity();
        return;
      }
      tsAuffrischen();
      namenSetzen(root, form);

      var payload = {};
      new FormData(form).forEach(function (v, k) { payload[k] = typeof v === 'string' ? v : String(v); });
      payload.consent = consent ? consent.checked : false;
      payload.personen = parseInt(payload.personen, 10);
      if (isNaN(payload.personen)) payload.personen = null;
      payload.ts = parseInt(payload.ts, 10) || 0;

      setBusy(true);
      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.text().then(function (t) {
          var body = null;
          try { body = t ? JSON.parse(t) : null; } catch (e) { body = null; }
          return { status: res.status, body: body };
        });
      }).then(function (res) {
        setBusy(false);
        var b = res.body || {};
        if (res.status === 200 || res.status === 207) {
          if (okText) okText.textContent = form.getAttribute(res.status === 200 ? 'data-t-ok' : 'data-t-ok-teil') || '';
          if (okBox) { okBox.hidden = false; if (typeof okBox.focus === 'function') okBox.focus(); }
          form.hidden = true;
          root.setAttribute('data-ms-stand', res.status === 200 ? 'gesendet' : 'gespeichert');
          return;
        }
        if (res.status === 400 && b.field) {
          showError(b.field === 'consent' ? (form.getAttribute('data-t-consent') || '') : (form.getAttribute('data-t-feld') || ''), b.field);
          return;
        }
        if (res.status === 404) { showError(form.getAttribute('data-t-notfound') || '', 'profil_id'); return; }
        if (res.status === 429) { showError(form.getAttribute('data-t-viele') || ''); return; }
        showError(form.getAttribute('data-t-error') || '');
      }).catch(function () {
        setBusy(false);
        showError(form.getAttribute('data-t-error') || '');
      });
    });
  }

  function alle() {
    var roots = document.querySelectorAll('[data-ms-bergfuehrer-anfrage]');
    for (var i = 0; i < roots.length; i++) formular(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  document.addEventListener('shopify:section:load', alle);
})();

  } catch(e) { console.error(e); }
})();
})();
